import React, { useState } from "react";
import {
  Button,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { MuiTelInput } from "mui-tel-input";
import { ClipLoader } from "react-spinners";
import { useCreateDayPassMutation } from "../../generated/graphql";
import { useSnackbar } from "notistack";

export const Home: React.FC = () => {
  const [firstName, setFirstName] = useState<string>("");
  const [lastName, setLastName] = useState<string>("");
  const [vrm, setVrm] = useState<string>("");
  const [phone, setPhone] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [tenantId, setTenantId] = useState<string>("");
  const [error, setError] = useState<string>("");

  const [createDayPass, {loading}] = useCreateDayPassMutation()
  const { enqueueSnackbar } = useSnackbar();

  const handleFirstNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setFirstName(event.target.value);
  };

  const handleLastNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setLastName(event.target.value);
  };

  const handleVrmChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setVrm(event.target.value);
  };

  const handlePhoneChange = (newPhone: string) => {
    setPhone(newPhone);
  };

  const handleEmailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(event.target.value);
  };

  const handleTenantIdChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setTenantId(event.target.value);
  };

  const canProcess = firstName && lastName && vrm && tenantId;

  const processPayment = async () => {
    const result = await createDayPass({
      variables: {
        firstName,
        lastName,
        vrm,
        phone,
        email,
        tenantId,
      }
    })
    if (result && result.data) {
      if (result.data.createDayPass.successful) {
        setError("")
        setFirstName("")
        setLastName("")
        setVrm("")
        setPhone("")
        setEmail("")
        setTenantId("")
        enqueueSnackbar("Day pass created", { variant: "success" })
      } else {
        setError(result.data.createDayPass.error || "Something went wrong")
      }
    } else {
      setError("Something went wrong")
    }
  }

  return (
    <Stack alignItems={"center"} spacing={2}>
      <TextField
        label="First Name"
        value={firstName}
        type="text"
        fullWidth
        onChange={handleFirstNameChange}
      />
      <TextField
        label="Last Name"
        value={lastName}
        type="text"
        fullWidth
        onChange={handleLastNameChange}
      />
      <TextField
        label="Vehicle Registration"
        value={vrm}
        fullWidth
        onChange={handleVrmChange}
      />
      <TextField
        label="Tenant Id"
        value={tenantId}
        type="text"
        fullWidth
        onChange={handleTenantIdChange}
      />
      <TextField
        label="Optional: Email"
        value={email}
        type="email"
        fullWidth
        onChange={handleEmailChange}
      />
      <MuiTelInput
        onlyCountries={["NZ", "CR"]}
        disableDropdown={!window.location.href.includes("?test=true")}
        label="Optional: Phone"
        defaultCountry="NZ"
        value={phone}
        inputProps={{
          maxLength: 16,
        }}
        fullWidth
        onChange={handlePhoneChange}
      />
      {error && <Typography color={"red"}>{error}</Typography>}
      <Button
        fullWidth
        disabled={!canProcess}
        sx={{ padding: 1 }}
        variant="contained"
        onClick={processPayment}
      >
        {loading ? (
          <ClipLoader color="white" />
        ) : 'Register'}
      </Button>
    </Stack>
  );
};
